// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconSharePrint: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <path
                fill="currentColor"
                d="M121,6 L109,6 C107.895312,6 107,6.8968749 107,8 L107,11 C107,11.5521879 107.447813,12 108,12 L109,12 L109,15 C109,15.5521879 109.447813,16 110,16 L120,16 C120.552188,16 121,15.5521879 121,15 L121,12 L122,12 C122.552188,12 123,11.5521879 123,11 L123,8 C123,6.8968749 122.103125,6 121,6 Z M119,14 L111,14 L111,11 L119,11 L119,14 Z M120.5,9.25 C120.085938,9.25 119.75,8.9140625 119.75,8.5 C119.75,8.08531284 120.085938,7.75 120.5,7.75 C120.914062,7.75 121.25,8.08531284 121.25,8.5 C121.25,8.91562462 120.915625,9.25 120.5,9.25 Z M111,2 L118.171875,2 L119,2.82843781 L119,5 L121,5 L121,2.4140625 C121,2.14893723 120.894531,1.89468765 120.707031,1.70718765 L119.292969,0.293125153 C119.10625,0.10546875 118.85,0 118.5875,0 L110,0 C109.448125,0 109,0.44781208 109,1 L109,5 L111,5 L111,2 Z"
                transform="translate(-107)"
            />
        </svg>
    );
};

export default React.memo(IconSharePrint);
